var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.343,
    height: 53.343,
    viewBox: "0 0 53.343 53.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.333 -6.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5360",
    cx: 23.337,
    cy: 23.337,
    r: 23.337,
    transform: "translate(9.667 9.667)",
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45933",
    d: "M1635.688 1859.443a26 26 0 1 1-26 26 26.033 26.033 0 0 1 26-26m0-.667a26.671 26.671 0 1 0 26.671 26.671 26.7 26.7 0 0 0-26.671-26.671z",
    transform: "translate(-1602.684 -1852.443)",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05 19.728a9.736 9.736 0 0 1-2.72.752 4.629 4.629 0 0 0 2.084-2.633A9.994 9.994 0 0 1 29.4 19a4.75 4.75 0 0 0-8.218 3.241 4.339 4.339 0 0 0 .116 1.071 13.359 13.359 0 0 1-9.752-4.948A4.762 4.762 0 0 0 13 24.705a4.557 4.557 0 0 1-2.141-.579 4.8 4.8 0 0 0 3.791 4.717 5.209 5.209 0 0 1-2.141.087 4.765 4.765 0 0 0 4.427 3.3A9.561 9.561 0 0 1 9.9 34.2a13.485 13.485 0 0 0 20.777-11.347 4.274 4.274 0 0 0-.029-.608 9.419 9.419 0 0 0 2.4-2.518z",
    transform: "translate(11.529 6.085)",
    style: {
      fill: "#151aae"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSocial);
export default __webpack_public_path__ + "static/media/twitter-social.38a7b9cdd81043b36d322ef5717fe29d.svg";
export { ForwardRef as ReactComponent };